export const WHAT_IS_NEW_UPDATED_AT_KEY = '@c360/ui/what-is-new/updated-at';
